export default __webpack_public_path__ + "static/media/E9.1669110d.jpg";